import * as Yup from 'yup';

export const validateLateFeeConfigSchema = Yup.object({
  lateFeeCharges: Yup.object({
    amount: Yup.number()
      .transform((value, originalValue) =>
        originalValue === '' ? null : value
      )
      .optional()
      .notRequired()
      .min(0, 'Amount must be at least 0'),
    percentage: Yup.number()
      .transform((value, originalValue) =>
        originalValue === '' ? null : value
      )
      .optional()
      .notRequired()
      .min(0, 'Percentage must be at least 0')
  }).required('Late fee charges are required'),
  chequeBounceCharges: Yup.number()
    .transform((value, originalValue) =>
      originalValue === '' ? undefined : value
    )
    .required('Cheque bounce charges are required')
    .min(0, 'Cheque bounce charges must be at least 0'),
  enachBounceCharges: Yup.number()
    .required('ENACH bounce charges are required')
    .min(0, 'ENACH bounce charges must be at least 0'),
  fineType: Yup.string()
    .oneOf(['PER_MONTH', 'PER_DAY'], 'Select a fine type')
    .required('Fine type is required'),
  maxLateFee: Yup.number()
    .transform((value, originalValue) =>
      originalValue === '' || originalValue === null ? null : value
    )
    .nullable()
    .optional()
    .notRequired()
    .min(0, 'Max late fee must be at least 0'),
  proRatedConfig: Yup.object({
    enabled: Yup.boolean(),
    proRateAfterCycles: Yup.number()
      .transform((value, originalValue) =>
        originalValue === '' ? null : value
      )
      .when('enabled', ([enabled], schema) =>
        enabled
          ? schema
              .min(1, 'Pro rate after cycles must be greater than 0')
              .required('Pro rate after cycles is required when enabled')
          : schema.notRequired()
      )
  }).optional()
});
